var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4872_83345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 4.66406H5.99935C5.26602 4.66406 4.66602 5.26406 4.66602 5.9974V13.9974L6.66602 11.9974H9.99935V11.3307C9.99935 9.86406 11.1927 8.66406 12.666 8.66406V5.9974C12.666 5.26406 12.066 4.66406 11.3327 4.66406ZM11.3327 6.66406H10.3327C10.106 7.4574 9.69268 8.1974 9.11935 8.8374L9.10602 8.85073L9.94602 9.68406L9.69935 10.3574L8.66602 9.33073L6.99935 10.9974L6.53935 10.5107L8.22602 8.85073C7.81863 8.39957 7.48558 7.8865 7.23935 7.33073H7.89935C8.10602 7.73073 8.35935 8.11073 8.66602 8.45073C9.13265 7.93245 9.48878 7.32453 9.71268 6.66406H5.99935V5.9974H8.33268V5.33073H8.99935V5.9974H11.3327V6.66406ZM17.9993 9.9974H12.666C11.9327 9.9974 11.3327 10.5974 11.3327 11.3307V15.9974C11.3327 16.7307 11.9327 17.3307 12.666 17.3307H17.3327L19.3327 19.3307V11.3307C19.3327 10.5974 18.7327 9.9974 17.9993 9.9974ZM17.086 16.6641L16.5194 15.1641H14.146L13.586 16.6641H12.586L14.8327 10.6641H15.8327L18.086 16.6641H17.086ZM15.3327 11.9974L16.146 14.1641H14.526L15.3327 11.9974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_83345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageFilledIcon);
export default __webpack_public_path__ + "static/media/language-filled-icon.bb635cc3d4a66277ad68ba801fe7d9b2.svg";
export { ForwardRef as ReactComponent };